import styles from './mediumHero.module.css';
import SignupButton from '../signupbutton/signupbutton';

const MediumHero = ({ imageUrl, altText, headline, paragraph, cta, ctaLink, height }) => {
    return (
        <div className={styles.mediumHeroContainer}>
            <img 
                    className={styles.mediumHeroBackgroundImage} 
                    src={imageUrl || "https://visitfaroeislands.com/download/kirstinvangbikesuuroy_large.jpg"}
                    alt={altText || "bakgrundsmynd"}
                />
                <div className={styles.mediumHeroContentOverlay}>
                    {headline && <h1 className={styles.frontpageTitle}>{headline}</h1>}
                    {paragraph && <p className={styles.frontpageDescription}>{paragraph}</p>}
                    {cta && <SignupButton text={cta} onClick={() => window.location.href = ctaLink} />}
                </div>
        </div>
    );
}

export default MediumHero;
